import { WorkflowState } from './workflow.ts';
import { z } from 'zod';

export const Claim = z.discriminatedUnion('name', [
    z.object({ name: z.literal('impersonate') }),
    z.object({ name: z.literal('sync') }),
    z.object({ name: z.literal('report') }),

    z.object({
        name: z.literal('read'),
        forState: WorkflowState.or(z.array(WorkflowState)).nullable(),
        forUser: z.string().or(z.array(z.string())).nullable(),
    }),

    z.object({
        name: z.literal('write'),
        forState: WorkflowState.or(z.array(WorkflowState)).nullable(),
        forUser: z.string().or(z.array(z.string())).nullable(),
    }),

    z.object({
        name: z.literal('delete'),
        forState: WorkflowState.or(z.array(WorkflowState)).nullable(),
        forUser: z.string().or(z.array(z.string())).nullable(),
    }),

    z.object({
        name: z.literal('transition'),
        fromState: WorkflowState.or(z.array(WorkflowState)).nullable(),
        toState: WorkflowState.or(z.array(WorkflowState)).nullable(),
        forUser: z.string().or(z.array(z.string())).nullable(),
    }),

    z.object({
        name: z.literal('editAdditionalApprovers'),
        forUser: z.string().or(z.array(z.string())).nullable(),
    }),

    z.object({
        name: z.literal('editSubsitution'),
        forUser: z.string().or(z.array(z.string())).nullable(),
    }),

    z.object({
        name: z.literal('acceptDuplicate'),
        forUser: z.string().or(z.array(z.string())).nullable(),
    }),

    z.object({
        name: z.literal('reviewDuplicate'),
        forUser: z.string().or(z.array(z.string())).nullable(),
    }),

    z.object({
        name: z.literal('payment.setup'),
    }),

    z.object({
        name: z.literal('payment.read'),
    }),

    z.object({
        name: z.literal('payment.request'),
    }),

    z.object({
        name: z.literal('jobs.read'),
    }),
]);
export type Claim = z.infer<typeof Claim>;
